var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.1346C12.9535 14.1346 14.9424 12.1457 14.9424 9.69231C14.9424 7.23889 12.9535 5.25 10.5 5.25C8.04663 5.25 6.05774 7.23889 6.05774 9.69231C6.05774 12.1457 8.04663 14.1346 10.5 14.1346Z",
    fill: "#A4A4A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C8.4233 0 6.39323 0.615814 4.66652 1.76957C2.9398 2.92332 1.59399 4.5632 0.799269 6.48182C0.00454949 8.40045 -0.203385 10.5116 0.201759 12.5484C0.606904 14.5852 1.60693 16.4562 3.07538 17.9246C4.54383 19.3931 6.41475 20.3931 8.45155 20.7982C10.4884 21.2034 12.5996 20.9954 14.5182 20.2007C16.4368 19.406 18.0767 18.0602 19.2304 16.3335C20.3842 14.6068 21 12.5767 21 10.5C20.9968 7.71619 19.8896 5.04731 17.9211 3.07886C15.9527 1.11041 13.2838 0.00315078 10.5 0ZM17.139 16.3972C16.4907 15.4578 15.6498 14.6671 14.6725 14.0776C13.5485 15.151 12.0542 15.75 10.5 15.75C8.94584 15.75 7.45147 15.151 6.32755 14.0776C5.35015 14.6671 4.50934 15.4578 3.86094 16.3972C2.72261 15.1172 1.97857 13.5354 1.71842 11.8423C1.45827 10.1492 1.6931 8.417 2.39464 6.85429C3.09618 5.29158 4.23451 3.96498 5.67255 3.03425C7.11059 2.10352 8.78703 1.60834 10.5 1.60834C12.2129 1.60834 13.8894 2.10352 15.3274 3.03425C16.7655 3.96498 17.9038 5.29158 18.6053 6.85429C19.3069 8.417 19.5417 10.1492 19.2816 11.8423C19.0214 13.5354 18.2774 15.1172 17.139 16.3972Z",
    fill: "#A4A4A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPerson);
export default __webpack_public_path__ + "static/media/ico-person.d67856582abfde681a27b94453cabd9c.svg";
export { ForwardRef as ReactComponent };